module.exports = __webpack_public_path__ + "img/arrow_drop_down.fe9dc10f.svg";